import CustomerCarousel from "../components/GetInTouch";
import Header from "../components/Header";

const Home = () => {
  return (
    <>
      <Header />
      <CustomerCarousel />
    </>
  );
};

export default Home;
